import { z } from "zod";
import { seedanceGenerationStateSchema } from "./generation.js";
import { exactTokenCountSchema } from "./generation-diagnostics.js";
const instant = z.string().datetime({ offset: true });
export const adminUsageFilterFields = {
  ownerId: z.uuid().optional(), projectId: z.uuid().optional(),
  model: z.string().trim().min(1).max(120).optional(), state: seedanceGenerationStateSchema.optional(),
  from: instant.optional(), toExclusive: instant.optional(), taskId: z.string().trim().min(1).max(320).optional()
};
export const adminUsageFilterSchema = z.strictObject(adminUsageFilterFields).refine(
  f => !f.from || !f.toExclusive || Date.parse(f.from) < Date.parse(f.toExclusive), "Invalid date range");
export const usageFieldSummarySchema = z.strictObject({
  knownTotal: z.string().max(40).regex(/^(0|[1-9]\d*)$/u),
  reportedCount: z.number().int().nonnegative().safe(), missingCount: z.number().int().nonnegative().safe()
});
export const adminUsageSummarySchema = z.strictObject({
  input: usageFieldSummarySchema, output: usageFieldSummarySchema, total: usageFieldSummarySchema,
  taskCount: z.number().int().nonnegative().safe()
});
export const adminUsageRowSchema = z.strictObject({
  generationId: z.uuid(), ownerId: z.uuid(), ownerName: z.string(), projectId: z.uuid(), projectName: z.string(),
  upstreamTaskId: z.string().optional(), model: z.string(), state: seedanceGenerationStateSchema, createdAt: instant,
  usage: z.strictObject({ inputTokens: exactTokenCountSchema.optional(), outputTokens: exactTokenCountSchema.optional(),
    totalTokens: exactTokenCountSchema.optional(), recordedAt: instant.optional(), invalidFields: z.array(z.enum(["input", "output", "total"])) })
});
export const adminUsagePageSchema = z.strictObject({ items: z.array(adminUsageRowSchema), summary: adminUsageSummarySchema,
  asOf: instant, nextCursor: z.string().optional() });
export type AdminUsageFilter = z.infer<typeof adminUsageFilterSchema>;
export type AdminUsageRow = z.infer<typeof adminUsageRowSchema>;
export type UsageFieldSummary = z.infer<typeof usageFieldSummarySchema>;
export type AdminUsageSummary = z.infer<typeof adminUsageSummarySchema>;
export type AdminUsagePage = z.infer<typeof adminUsagePageSchema>;
export interface AdminUsageExport { rows: AdminUsageRow[]; summary: AdminUsageSummary; asOf: string }
export const adminOverviewSchema = z.strictObject({ asOf: instant,
  memberCounts: z.strictObject({ active: z.number().int().nonnegative(), disabled: z.number().int().nonnegative() }),
  taskCounts: z.record(seedanceGenerationStateSchema, z.number().int().nonnegative()), usage: adminUsageSummarySchema, pendingFeedbackCount: z.number().int().nonnegative() });
export type AdminOverview = z.infer<typeof adminOverviewSchema>;
